import { render, staticRenderFns } from "./ImageUploadArea.vue?vue&type=template&id=176654a6&lang=pug"
import script from "./ImageUploadArea.vue?vue&type=script&lang=js"
export * from "./ImageUploadArea.vue?vue&type=script&lang=js"
import style0 from "./ImageUploadArea.vue?vue&type=style&index=0&id=176654a6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports